import TpClientInvoiceStatusEnum from '../Enums/ClientInvoiceStatusEnum';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import React from 'react';

export default class TpClientInvoiceReducedListItem {
  constructor(item) {
    if (item === undefined) {
      this.TpClientInvoiceId = null;
      this.CaspianClientName = '';
      this.CaspianClientId = '';
      this.Ponumber = '';
      this.FinalizedOnUtc = new Date();
      this.Count = item.count;
      this.InternalReferenceNumber = '';
    } else {
      this.TpClientInvoiceId = item.tpClientInvoiceId;
      this.CaspianClientId = item.caspianClientId;
      this.CaspianClientName = item.caspianClientName;
      this.Ponumber = item.ponumber ? item.ponumber : ' ';
      this.FinalizedOnUtc = item.status !== TpClientInvoiceStatusEnum.Draft ? item.finalizedOnUtc : new Date();
      this.Count = item.count;
      this.InternalReferenceNumber = item.internalReferenceNumber ? item.internalReferenceNumber : ' ';
    }
    this.Selected = false;
  }

  static DateFields = ['FinalizedOnUtc'];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Selected',
        orderById: '',
        data: TpClientInvoiceReducedListItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 20,
      },
      {
        label: 'BARE #',
        orderById: 'TpClientInvoiceId',
        data: 'TpClientInvoiceId',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Client #',
        orderById: (item) => `${item.CaspianClientName} (${item.CaspianClientId})`,
        data: 'CaspianClientName',
        type: FieldTypesEnum.PureDataField,
        minWidth: 140,
      },
      {
        label: 'PO #',
        orderById: 'Ponumber',
        data: 'Ponumber',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Invoiced On',
        orderById: 'FinalizedOnUtc',
        data: 'FinalizedOnUtc',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Items',
        orderById: 'Count',
        data: 'Count',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Internal Reference',
        orderById: 'InternalReferenceNumber',
        data: 'InternalReferenceNumber',
        type: FieldTypesEnum.PureDataField,
      },
    ];
  }

  static getSelectedCellContent(item) {
    if (item.Selected === undefined) item.Selected = false;
    return (
      <div className='text-center'>
        <input
          type='radio'
          checked={item.Selected}
          onClick={(e) => {
            TpClientInvoiceReducedListItem.clickOnSelect(item);
          }}
          onChange={(e) => {}} //Don't remove. This is necessary to eliminate the React warning!
        />
      </div>
    );
  }

  static clickOnSelect(item) {
    alert('Click');
  }
}
